import React, { useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import EditUserModal from '../../Components/Modals/EditUserModal'
import InventoryModal from '../../Components/Modals/InventoryModal'
import { addInventory, getInventory } from '../../Services/inventoryService'
import toast from 'react-hot-toast'
import { Form } from 'react-bootstrap'
import AppPagination from '../../Components/AppPagination'

const Inventory = () => {



    const [inventory, setInventory] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState(null)
    const [loading, setLoading] = useState(false)

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)

    const [editData, setEditData] = useState({
        product_name: "",
        quantity: "",
        price: ""
    })

    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const companyId = useSelector(state => state.auth.companyId);
    const companyPin = useSelector(state => state.auth.companyPin);

    const base64Pin = btoa(companyPin);

    const handleInventoryData = async () => {
        try {
            setLoading(true);

            const response = await getInventory(
                base64Pin,
                page,
                limit,
                startDate,
                endDate
            );

            if (response?.status === "success") {
                setInventory(response?.data || []);
                setTotalPages(response?.pagination?.totalPages || 1);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (base64Pin) {
            handleInventoryData();
        }
    }, [base64Pin, page, startDate, endDate]);

    // ✅ ADD USER
    const handleAdd = () => {
        setIsEdit(false)
        setSelectedUserId(null)

        setEditData({
            product_name: "",
            quantity: "",
            price: ""
        })

        setShowModal(true)
    }

    // ✅ EDIT USER
    // const handleEdit = (user) => {
    //     setIsEdit(true)
    //     setSelectedUserId(user.id)

    //     setEditData({
    //         product_name: user.product_name || "",
    //         quantity: user.quantity || "",
    //         price: user.price || ""
    //     })

    //     setShowModal(true)
    // }

    // ✅ SUBMIT (ADD + EDIT)
    const handleSubmit = async () => {
        if (!editData.product_name || !editData.quantity || !editData.price) {
            toast.error("Please fill all fields")
            return
        }


        setLoading(true)

        const body = {
            ...editData,
            company_pin: base64Pin
        }

        let response

        if (isEdit) {
            response = await addInventory(body)
            // response = await updateUser(selectedUserId, body)
        } else {
            response = await addInventory(body)
        }

        setLoading(false)

        if (response?.status === "success") {
            toast.success(response.message)
            setShowModal(false)
            handleInventoryData()
        } else {
            toast.error(response?.message || "Something went wrong")
        }
    }

    // const handleDelete = async (id) => {
    //     const response = await deleteUser(id);
    //     if (response?.status === "success") {
    //         toast.success(response?.message || "User deleted");
    //         handleGetUserData();
    //     } else toast.error(response?.message || "Delete failed");
    // };

    // const handleConfirmDelete = async () => {
    //     if (!selectedUser) return

    //     setLoading(true)

    //     const response = await deleteUser(selectedUser.id)

    //     setLoading(false)

    //     if (response?.status === "success") {
    //         toast.success(response?.message || "User deleted")
    //         setShowDeleteModal(false)
    //         setSelectedUser(null)
    //         handleGetUserData()
    //     } else {
    //         toast.error(response?.message || "Delete failed")
    //     }
    // }


    return (

        <div>

            {/* HEADER */}
            <div className="d-flex justify-content-between mb-3">
                <h4>Inventory</h4>

                <button className="oms-btn oms-btn-primary"
                    onClick={handleAdd}
                >
                    <FaPlus size={12} /> Add Inventory
                </button>
            </div>

            <div className="row g-2 mb-3 justify-content-end">
                <div className="col-auto">
                    <Form.Label className='oms-label-dark'>From</Form.Label>

                    <input
                        type="date"
                        className="oms-input-dark form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>

                <div className="col-auto">

                    <Form.Label className='oms-label-dark'>To</Form.Label>
                    <input
                        type="date"
                        className="oms-input-dark form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />

                </div>
            </div>

            {/* TABLE */}
            <div className="oms-table-wrap">
                {inventory.length === 0 ? (
                    <div className="oms-empty">No inventory found</div>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Value</th>
                                <th>Date</th>
                                {/* <th>Action</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {inventory.map((item, index) => (
                                <tr key={index}>

                                    {/* INDEX */}
                                    <td>{(page - 1) * limit + index + 1}</td>

                                    {/* TRACKING */}
                                    <td>
                                        <div className="oms-customer">{item.product_name}</div>
                                    </td>


                                    {/* CUSTOMER */}
                                    <td>
                                        <div className="oms-customer" >
                                            {item.quantity}
                                        </div>
                                    </td>

                                    {/* CITY */}
                                    <td>
                                        <div className="oms-track-id" >
                                            RS:  {item.price}
                                        </div>
                                    </td>


                                    {/* QTY */}
                                    <td>
                                        <div style={{ fontSize: 12, color: "white" }}>
                                            {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : "N/A"}
                                        </div>
                                    </td>



                                    {/* STATUS CHANGE DROPDOWN */}

                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <div className="oms-table-footer ">
                    <AppPagination page={page} totalPages={totalPages} onPageChange={setPage} />
                </div>
            </div>

            {/* ✅ SINGLE MODAL */}
            <InventoryModal
                showModal={showModal}
                setShowModal={setShowModal}
                editData={editData}
                setEditData={setEditData}
                handleSubmit={handleSubmit}
                loading={loading}
                isEdit={isEdit}
            />



        </div >

    )
}

export default Inventory